import { useEffect, useState, type ReactNode } from 'react';
import { Button, Dialog } from '@org/design-system';
import type { ShadcnDialogConfig } from './types';
import { useCollaborationPresence } from './collaboration/useCollaborationPresence';

interface DialogRendererProps {
  config: ShadcnDialogConfig;
  children: ReactNode;
  presenceRowId?: string | null;
}

export function DialogRenderer({ config, children, presenceRowId = null }: DialogRendererProps) {
  const [open, setOpen] = useState(false);
  const { setSelectedRowId } = useCollaborationPresence();

  useEffect(() => {
    if (!open) {
      setSelectedRowId(null);
      return;
    }

    setSelectedRowId(presenceRowId);
  }, [open, presenceRowId, setSelectedRowId]);

  return (
    <>
      <Button variant={config.triggerVariant ?? 'primary'} onClick={() => setOpen(true)}>
        {config.triggerLabel ?? 'Open Dialog'}
      </Button>

      <Dialog
        isOpen={open}
        onClose={() => setOpen(false)}
        title={config.title}
        description={config.description}
      >
        {children}
      </Dialog>
    </>
  );
}
